import {
  FC,
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from 'react';

type ICallbackFn = () => void;

interface IConfirmModalContextData {
  isOpen: boolean;
  modalTitle: string;
  openConfirmModal: (
    modalTitleProp: string,
    callbackFnProp: () => void
  ) => void;
  closeConfirmModal: () => void;
  callbackFn: ICallbackFn;
}

const ConfirmModalContext = createContext({} as IConfirmModalContextData);

const ConfirmModalProvider: FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');

  const callbackFnRef = useRef<any>(null);

  const openConfirmModal = useCallback(
    (modalTitleProp: string, callbackFn: ICallbackFn) => {
      callbackFnRef.current = callbackFn;

      setModalTitle(modalTitleProp);
      setIsOpen(true);
    },
    []
  );

  const closeConfirmModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <ConfirmModalContext.Provider
      value={{
        isOpen,
        modalTitle,
        openConfirmModal,
        closeConfirmModal,
        callbackFn: callbackFnRef.current,
      }}
    >
      {children}
    </ConfirmModalContext.Provider>
  );
};

const useConfirmModal = (): IConfirmModalContextData => {
  return useContext(ConfirmModalContext);
};

export { ConfirmModalProvider, useConfirmModal };
